import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {AppState} from '../../redux/store';
import JwtDecode from 'jwt-decode';
import {logoutUser} from '../../redux/actions/Auth';

const USABLE_TIME_LEFT = 5 * 1000;

export const useAuthToken = () => {
  const dispatch = useDispatch();
  const [token, setToken] = useState<string | null>(null);
  const {user} = useSelector<AppState, AppState['auth']>(({auth}) => auth);
  const authUser = user;
  useEffect(() => {
    // const checkAuth = () => {
    //   Promise.all([firebaseCheck()]).then(() => {
    //     setLoading(false);
    //   });
    // };
    // checkAuth();
  }, [dispatch]);

  useEffect(() => {
    if (!authUser) {
      setToken(null);
    }
    if (authUser && authUser.token) {
      setToken(authUser.token);
    }
  }, [authUser]);

  useEffect(() => {
    if (token) {
      const decodedToken = JwtDecode<{exp: number}>(token);
      const timeLeft = decodedToken.exp * 1000 - Date.now();

      const logOutUser = () => {
        dispatch(logoutUser());
      };

      if (timeLeft > USABLE_TIME_LEFT) {
        const timeout = setTimeout(logOutUser, timeLeft);
        return () => {
          clearTimeout(timeout);
        };
      } else {
        logOutUser();
      }
    }
  }, [token]);

  return [token];
};

export const useAuthUser = () => {
  const {user} = useSelector<AppState, AppState['auth']>(({auth}) => auth);
  if (user) {
    return user;
  }
  return null;
};
